import { FC } from "react";
import { Box, Card, Flex, Heading, Text } from "@radix-ui/themes";
import DateObject from "react-date-object";

interface SingleEventMetaProps {
  startDate: DateObject;
  endDate: DateObject;
  location: string;
}

export const SingleEventMeta: FC<SingleEventMetaProps> = ({
  startDate,
  endDate,
  location,
}): JSX.Element => {
  return (
    <Card>
      <Flex direction="column" gap="3">
        <Box>
          <Heading as="h2" size="3">
            Location
          </Heading>
          <Text as="p">{location}</Text>
        </Box>
        <Box>
          <Heading as="h2" size="3">
            Dates
          </Heading>
          <Text as="p">
            {startDate.format("DD.MM.YYYY")} - {endDate.format("DD.MM.YYYY")}
          </Text>
        </Box>
      </Flex>
    </Card>
  );
};
